import { Button, ComponentStyle} from '@/imports-files/components/confirmation-modal';
import { AgencyModalStyle} from '@/imports-files/components/confirmation-modal';
import { FormModalStyle, Close } from "@/imports-files/components/common-modal/common-modal";

export function AgencyAcceptRejectModal(props)
{

  let heightClass = props.heightClass ? props.heightClass : '';
  let widthClass = props.widthClass ? props.widthClass : '';
  let buttonwidth = props.buttonwidth ? props.buttonwidth : '';
  return(

      <div className={`${FormModalStyle.ModalOverlay}`}>
        <div className={`${FormModalStyle.Modal}`}>
          <div className={`${FormModalStyle.Modal__Container}`}>
            <div
              className={`${FormModalStyle.Modal__Container__CloseSection}`}
              onClick={() => {
                props.setAgencyAcceptReject({status: false});
              }}>
               <Close/>
              CLOSE
              </div>
               <div className={`${FormModalStyle.Modal__Container__ContentSection} mt30`}>
                <h1 className={`${FormModalStyle.Modal__Container__ContentSection__SubHeading} mb15`}>A <span>duplicate candidate</span> has been submitted:</h1>
                <span className={AgencyModalStyle.ConfirmationModal__SubText}>User: <span>{props.viewData.agency_user_name}</span></span>
                <span className={AgencyModalStyle.ConfirmationModal__SubText}>Agency: <span>{props.viewData.agency_name}</span></span>
                <span className={AgencyModalStyle.ConfirmationModal__SubText}>Job: <span>{props.viewData.job_title}</span></span>
                <span className={AgencyModalStyle.ConfirmationModal__SubText}>Candidate Name: <span>{props.viewData.candidate_name}</span></span>
                <span className={AgencyModalStyle.ConfirmationModal__SubText}>Date Submitted: <span>{props.viewData.date_submitted}</span></span>
                <span className={AgencyModalStyle.ConfirmationModal__NewText}>{"Would you like to accept the application?"}</span>
               </div>
               <div className={FormModalStyle.Modal__Container__ButtonSection}>
                <Button buttonstyle={`${FormModalStyle.secondarybtn}`}   onClick={() => {props.closeModal()}}> {props?.texts?.button1_text || 'Decline'} </Button>
                <Button buttonstyle={`${FormModalStyle.primarybtn}`} onClick={() => {props.btnAction()}}> {props?.texts?.button2_text || 'Accept'}</Button>
               </div>
          </div>
        </div>
      </div>


        )
}

